import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as AppConfigActions from "../../actions/appConfigActions";
import * as constants from "../../constants";

const loadAppConfigLogic = createLogic({
	type: ActionTypes.LOAD_APP_CONFIG,
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				let api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/apps/${action.appKey}/config`)
					.then(res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(AppConfigActions.loadAppConfigSuccess(res.data, action.appKey));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(AppConfigActions.loadAppConfigSuccess(error));
						done();
					});
			});
	},
});

export default [loadAppConfigLogic];
